module.exports = __webpack_public_path__ + "static/media/15.ae7ccb0e.jpg";